module.exports = __webpack_public_path__ + "media/plim.3b78d849.mp3";